import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Checkbox,
  TextArea
} from 'semantic-ui-react'

const ModReprintDrugOrderUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="ModReprintDrugOrderUX-div-0"
        style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
        <div
          id="ModReprintDrugOrderUX-div-9"
          style={{ backgroundColor: "#2185D0", color: "white", fontSize: "1.2rem", padding: "10px"}}>
          {props.languageUX === "en" ? "Confirm Reprint ?" : "ยืนยัน Reprint ?"}
        </div>
        <div
          id="ModReprintDrugOrderUX-div-10"
          style={{padding: "10px", display: "flex", flexDirection: "column"}}>
          
          <div
            id="ModReprintDrugOrderUX-div-12"
            style={{ display: "flex",  flexDirection: "column", justifyContent: "center"}}>
            
            <Checkbox
              checked={props.printMedicine}
              id="ModReprintDrugOrderUX-Checkbox-30"
              label={props.languageUX === "en" ? "Medication receipt for nurses" : "ใบรับยาสำหรับพยาบาล"}
              onChange={props?.handleChangeChecked("printMedicine")}>
            </Checkbox>
            <Checkbox
              checked={props?.printPharma}
              id="ModReprintDrugOrderUX-Checkbox-18"
              label={props.languageUX === "en" ? "Pharmacist's prescription summary" : "ใบสรุปรายการสั่งยาของเภสัชกร"}
              onChange={props?.handleChangeChecked("printPharma")}
              style={{marginTop: "5px"}}>
            </Checkbox>
            <Checkbox
              checked={props?.printPatient}
              id="ModReprintDrugOrderUX-Checkbox-19"
              label={props.languageUX === "en" ? "Patient's medication order summary" : "ใบสรุปรายการสั่งยาของผู้ป่วย"}
              onChange={props?.handleChangeChecked("printPatient")}
              style={{marginTop: "5px"}}>
            </Checkbox>
            <Checkbox
              checked={props?.printLabel}
              id="ModReprintDrugOrderUX-Checkbox-20"
              label={props.languageUX === "en" ? "Drug label" : "ฉลากยา"}
              onChange={props?.handleChangeChecked("printLabel")}
              style={{marginTop: "5px"}}>
            </Checkbox>
            <Checkbox
              checked={props?.printMedReport}
              id="ModReprintDrugOrderUX-Checkbox-29"
              label={props.languageUX === "en" ? "Take-home medication list" : "ใบแสดงรายการยากลับบ้าน"}
              onChange={props?.handleChangeChecked("printMedReport")}
              style={{marginTop: "5px", display: props.isHomeMed ? "" : "none" }}>
            </Checkbox>
          </div>
          <div
            id="ModReprintDrugOrderUX-div-21"
            style={{marginTop:"10px"}}>
            
            <div
              id="ModReprintDrugOrderUX-div-22">
              {props.languageUX === "en" ? "Note" : "บันทึก"}
            </div>
            <div
              id="ModReprintDrugOrderUX-div-23"
              style={{marginTop:"5px",marginBottom:"5px"}}>
              
              <TextArea
                id="ModReprintDrugOrderUX-TextArea-24"
                onChange={props?.handleChangeValue("noteReprint")}
                style={{width:"100%"}}
                value={props?.noteReprint}>
              </TextArea>
            </div>
          </div>
          <div
            id="ModReprintDrugOrderUX-div-25"
            style={{display: "flex"}}>
            
            <div
              id="ModReprintDrugOrderUX-div-26"
              style={{marginTop:"10px"}}>
              ฉลากยาภาษา 
            </div>
            <div
              id="ModReprintDrugOrderUX-div-27"
              style={{marginLeft:"10px"}}>
              {props?.language}
            </div>
          </div>
          <div
            id="ModReprintDrugOrderUX-div-15"
            style={{padding: "20px", display: "flex", alignItems: "center", justifyContent: "space-evenly"}}>
            
            <Button
              className="basic"
              color="green"
              id="ModReprintDrugOrderUX-Button-16"
              onClick={props.onConfirm}
              style={{width:"100px"}}>
              {props.languageUX === "en" ? "yes" : "ใช่"}
            </Button>
            <Button
              className="basic"
              color="red"
              id="ModReprintDrugOrderUX-Button-17"
              onClick={props.onCancel}
              style={{width:"100px"}}>
              {props.languageUX === "en" ? "no" : "ไม่"}
            </Button>
          </div>
          <div
            id="ModReprintDrugOrderUX-div-28">
            {props?.loading}
          </div>
        </div>
      </div>
    )
}


export default ModReprintDrugOrderUX

export const screenPropsDefault = {"diDetail":"ทดสอบ","needNote":true}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", display: \"flex\", flexDirection: \"column\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยัน Reprint ?",
          "valueEN": "Confirm Reprint ?"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{ backgroundColor: \"#2185D0\", color: \"white\", fontSize: \"1.2rem\", padding: \"10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", display: \"flex\", flexDirection: \"column\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",  flexDirection: \"column\", justifyContent: \"center\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"20px\", display: \"flex\", alignItems: \"center\", justifyContent: \"space-evenly\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "className": {
          "type": "value",
          "value": "basic"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-Button-16"
        },
        "onClick": {
          "type": "code",
          "value": "props.onConfirm"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100px\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ไม่",
          "valueEN": "no"
        },
        "className": {
          "type": "value",
          "value": "basic"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancel"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100px\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Checkbox",
      "parent": 12,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.printPharma"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-Checkbox-18"
        },
        "label": {
          "type": "value",
          "value": "ใบสรุปรายการสั่งยาของเภสัชกร",
          "valueEN": "Pharmacist's prescription summary"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleChangeChecked(\"printPharma\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"5px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Checkbox",
      "parent": 12,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.printPatient"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-Checkbox-19"
        },
        "label": {
          "type": "value",
          "value": "ใบสรุปรายการสั่งยาของผู้ป่วย",
          "valueEN": "Patient's medication order summary"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleChangeChecked(\"printPatient\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"5px\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Checkbox",
      "parent": 12,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.printLabel"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-Checkbox-20"
        },
        "label": {
          "type": "value",
          "value": "ฉลากยา",
          "valueEN": "Drug label"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleChangeChecked(\"printLabel\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"5px\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"10px\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "Note"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-22"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"5px\",marginBottom:\"5px\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "TextArea",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-TextArea-24"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleChangeValue(\"noteReprint\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props?.noteReprint"
        }
      },
      "seq": 24,
      "void": true
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "ฉลากยาภาษา "
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"10px\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.language"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"10px\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.loading"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-div-28"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Checkbox",
      "parent": 12,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.printMedReport"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-Checkbox-29"
        },
        "label": {
          "type": "value",
          "value": "ใบแสดงรายการยากลับบ้าน",
          "valueEN": "Take-home medication list"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleChangeChecked(\"printMedReport\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"5px\", display: props.isHomeMed ? \"\" : \"none\" }"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Checkbox",
      "parent": 12,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.printMedicine"
        },
        "id": {
          "type": "value",
          "value": "ModReprintDrugOrderUX-Checkbox-30"
        },
        "label": {
          "type": "value",
          "value": "ใบรับยาสำหรับพยาบาล",
          "valueEN": "Medication receipt for nurses"
        },
        "onChange": {
          "type": "code",
          "value": "props?.handleChangeChecked(\"printMedicine\")"
        }
      },
      "seq": 18,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 45,
  "isMounted": true,
  "memo": false,
  "name": "ModReprintDrugOrderUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "diDetail": "ทดสอบ",
    "needNote": true
  },
  "width": 30
}

*********************************************************************************** */
